<template lang="pug">
.bg-page
  .container
    .ticket-success
      h2 察看票卷
      .row(v-if="getUser.registered.me && getUser.registered.me.status === 4")
        .section-wrap.info-schedule.col-md-6.col-xs-12
          .ticket-bg(:class="{'ticket-bg--horizon': !isMobile, 'ticket-bg--straight': isMobile}")
            .ticket-name {{ getUser.payment.description }}
            .seat-number(v-if="getUser.registered.me.section")
              .section {{ getUser.registered.me.section }} 區
              .seat {{ getUser.registered.me.section }}{{ getUser.registered.me.human_x }}-{{ getUser.registered.me.human_y }}
            .seat-number(v-if="!getUser.registered.me.section")
              span 尚未劃位
            .user-info
              .user-info-row.ticket-id
                .info-name 票卷編號：
                .info-content {{ getUser.registered.me.ticket_no}}
              .user-info-row.nickname
                .info-name 帳號：
                .info-content {{ getUser.registered.me.gamers_account }}
              .user-info-row.user-id
                .info-name 身份證後四碼：
                .info-content {{ getUser.registered.me.id_number }}
            .qr-code
              img(:src="getUser.registered.me.qr_code_image_url")
      .row
        .coupons(v-if="getUser.registered.me && getUser.registered.me.coupons.length > 0")
          .title
            span 相關優惠代碼
            span(v-if="getUser.registered.me.coupons.length > 3", @click="toggleCoupon")
              .btn.btn-xs(v-if="couponSwitch === 3") 展開
              .btn.btn-xs(v-else) 關閉
          .coupons-wrap
            .coupon(v-if="index < couponSwitch", v-for="(coupon, index) in getUser.registered.me.coupons")
              a(href="https://www.elementaltotem.com/pages/wirforce", target="_blank").source {{ coupon.source }}
              .name {{ coupon.type }}
              .code {{ coupon.code }}
              .description {{ coupon.description }}
            //- .coupon(v-if="index < couponSwitch", v-for="(coupon, index) in coupons")
              a(href="#", target="_blank").source {{ coupon.source }}
              .name {{ coupon.type }}
              .code {{ coupon.code }}
              .description {{ coupon.description }}
            span(v-if="getUser.registered.me.coupons.length > 3", @click="openCoupon")
              .btn.ghost-btn(v-if="couponSwitch === 3") 全部優惠卷
      .row
        .section-wrap.info-schedule.col-md-6.col-xs-12
          .title 訂單資訊
          .content.border-styled(v-if="getUser.registered.me")
            img.icon(src="~assets/submit-success-icon.png")
            span(v-if="getUser.registered.me") {{ getUser.registered.me.status_string }}
            div(v-if="getUser.registered.me && getUser.registered.me.status !== 1 && getUser.registered.me.status !== 5")
              hr(v-if="getUser.payment.payments_code")
              ul.payment-code(v-if="getUser.payment.payments_code")
                li 繳費代碼
                li {{ getUser.payment.payments_code }}
              hr
              ul.payment-detail
                li
                  span 商品名稱
                  span {{ getUser.payment.description }}
                li
                  span 訂單編號
                  span {{ getUser.payment.order_id }}
                li
                  span 金額
                  span {{ getUser.payment.amount }}
                li(v-if="getUser.payment.expired_at")
                  span 繳費期限
                  span {{ getUser.payment.expired_at }}
          .content.border-styled(v-else)
            img.icon(src="~assets/submit-success-icon.png")
            span 尚未購票
            span(v-if="errmsg")  - {{ errmsg.type }}
          .mb-3
          router-link.btn.ghost-btn(:to="{name: 'payment'}", target="_blank") 代碼繳費說明
      .row
        .section-wrap.col-md-12
          .title 報名資訊
          .row
            //- .col-md-4(v-if="getUser.registered.me")
              .apply-info.isMe(:class="{'isLeader': getUser.registered.me.is_leader === 1}")
                .content.border-styled.ltr-block
                  .row
                    ul.title.col-md-5
                      li(v-if="getUser.registered.me.gamers_account") 帳號
                      li(v-if="getUser.registered.me.id_number") 身分證末四碼
                      li(v-if="getUser.registered.me.email") Email
                    ul.text.col-md-7
                      li {{ getUser.registered.me.gamers_account }}
                      li {{ getUser.registered.me.id_number }}
                      li {{ getUser.registered.me.email }}
            .col-md-4(v-if="getUser.registered.group", v-for="register in getUser.registered.group")
              .apply-info(:class="{'isLeader': register.is_leader === true, 'isMe': register.is_me === true}")
                .content.border-styled.ltr-block
                  .row
                    ul.title.col-md-5
                      li(v-if="register.name") 暱稱
                      li(v-if="register.gamers_account") 帳號
                      li(v-if="register.id_number && register.id_number.length > 1") 身分證末四碼
                      li(v-if="register.email && register.email.length > 1")  Email
                    ul.text.col-md-7
                      li {{ register.nickname }}
                      li {{ register.gamers_account }}
                      li(v-if="register.id_number && register.id_number.length > 1") {{ register.id_number }}
                      li(v-if="register.email && register.email.length > 1") {{ register.email }}
            .col-md-4(v-if="!getUser.registered.me && !getUser.registered.group")
              router-link(:to="{name: 'ticketType'}").btn.ghost-btn 前往購票
      hr
      .row(v-if="getUser.seats")
        .section-wrap.col-md-12
          .row
            .col-md-12
              .title 已劃位
            .col-md-4(v-if="!getUser.seats.chosen")
              .apply-info
                .content.border-styled.ltr-block
                  .row
                    ul.text
                      li 尚無人劃位
            .col-md-4(v-else, v-for="member in getUser.seats.chosen")
              .apply-info(:class="{'isLeader': member.is_leader, 'isMe': member.is_me}")
                .content.border-styled.ltr-block
                  .row
                    ul.title.col-md-4
                      li.seat-id 座位
                      li 暱稱
                      li 帳號
                      li(v-if="member.email && member.email.length > 1") Email
                    ul.text.col-md-8
                      li.seat-id {{ member.section }}{{ member.human_seat_x }}-{{ member.human_seat_y}}
                      li {{ member.nickname }}
                      li {{ member.gamers_account }}
                      li(v-if="member.email && member.email.length > 1") {{ member.email }}
            .col-md-12
              .title 尚未劃位
            .col-md-4(v-if="!getUser.seats.unChosen")
              .apply-info
                .content.border-styled.ltr-block
                  .row
                    ul.text
                      li 全數劃位完成
            .col-md-4(v-else, v-for="member in getUser.seats.unChosen")
              .apply-info(:class="{'isLeader': member.is_leader, 'isMe': member.is_me}")
                .content.border-styled.ltr-block
                  .row
                    ul.title.col-md-4
                      li 暱稱
                      li 帳號
                      li(v-if="member.email && member.email.length > 1") Email
                    ul.text.col-md-8
                      li {{ member.nickname }}
                      li {{ member.gamers_account }}
                      li(v-if="member.email && member.email.length > 1") {{ member.email }}
      .btn-wrap(v-if="getUser.registered.me && getUser.registered.me.status === 4 && this.getUser.registered.me.is_leader === true")
        .btn.ghost-btn(@click="sendNotification") 通知團員劃位
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import _ from 'lodash'

export default {
  name: 'user',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchRegistered().then((res) => {
        console.log('status: ', res.me.status)
        if (res.me.status !== 1 && res.me.status !== 5) {
          vm.fetchPayment()
        }
        vm.fetchUserSeats()
      }, (err) => {
        console.log('err', err)
        vm.errmsg = err
      })
    })
  },
  props: {
    isMobile: {
      type: Boolean
    }
  },
  data () {
    return {
      couponSwitch: 999,
      'coupons': [],
      errmsg: ''
    }
  },
  computed: {
    ...mapGetters([
      'getUser'
    ])
  },
  mounted () {
  },
  methods: {
    ...mapActions([
      'fetchRegistered',
      'fetchPayment',
      'fetchUserSeats',
      'seatsNotification'
    ]),
    openCoupon () {
      this.couponSwitch = 999
    },
    toggleCoupon () {
      if (this.couponSwitch === 999) {
        this.couponSwitch = 3
      } else {
        this.couponSwitch = 999
      }
    },
    sendNotification () {
      console.log('sendNotification')
      if (this.getUser.registered.me.is_leader && this.getUser.registered.me.is_leader === 1) {
        this.seatsNotification().then((res) => {
          if (res.type === 'success_notification') {
            this.$swal({
              type: 'success',
              tittle: '成功送出通知',
              text: '於 ' + res.expired_at + ' 後即可重新通知'
            })
          } else if (res.type === 'send_notification_times_limit') {
            this.$swal({
              type: 'info',
              title: '已發送過通知',
              text: '於 ' + res.expired_at + ' 後即可重新通知'
            })
          }
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/mixin'
@import '~stylesheets/components'
.border-styled
  border: 1px solid $grey
  padding: 16px
  +border-radius(2px)
.section-wrap
  font-size: 16px
  margin-bottom: 24px
  &:first-child
    margin-top: 36px
  &.success-msg
    line-height: 160%
  &.info-schedule
    .icon
      margin-right: 16px
  .title
    font-weight: bold
    font-size: 18px
    margin-bottom: 16px
  .content
    color: $grey
  .payment-code
    padding: 0 8px
    list-style: none
    font-size: 20px
    li
      &:first-child
        font-size: 14px
        color: $grey
      &:last-child
        color: #fff
        font-weight: bold
        letter-spacing: 2px
  .payment-detail
    list-style: none
    padding: 0 8px
    display: table
    position: relative
    width: 100%
    li
      display: table-row
      span
        display: table-cell
        border-bottom: 1px solid $grey-dark
        color: #fff
        &:first-child
          color: $grey
          text-align
          font-size: 14px
      &:not(:first-child)
        span
          padding-top: 6px
      &:not(:last-child)
        span
          padding-bottom: 6px
      &:last-child
        span
          border-bottom: none
  .apply-info
    margin: 20px 0
    overflow: hidden
    position: relative
    .content.ltr-block
      @extend %clearfix
      ul
        list-style: none
        padding: 0
        margin: 0
        font-size: 15px
        &.title
          float: left
          color: #fff
          padding-left: 16px
        &.text
          float: left
          padding-left: 16px
          max-width: 100%
          overflow: hidden
        li
          line-height: 180%
          &.seatId
            color: $green
    &.isLeader
      .border-styled
        border: 1px solid #fff
      &:before
        content: '隊長'
        background-color: #FFF
        color: $black
        font-size: 13px
        padding: 3px 10px
        position: absolute
        right: 0
        top: 0
    &.isMe
      .border-styled
        border: 1px solid $green
      .content
        ul
          &.title
            color: $green
      &:after
        content: '我'
        background-color: $green
        color: $black
        font-size: 13px
        padding: 3px 10px
        position: absolute
        right: 0
        top: 0
    &.isMe.isLeader
      .border-styled
        border: 1px solid $green
      .content
        ul
          &.title
            color: $green
      &:after
        content: '我, 隊長'
        background-color: $green
        color: $black
        font-size: 13px
        padding: 3px 10px
        position: absolute
        right: 0
        top: 0
.content.ltr-block
  @extend %clearfix
  ul
    list-style: none
    padding: 0
    margin: 0
    font-size: 15px
    &.title
      float: left
      color: #fff
      padding-left: 16px
    &.text
      float: left
      padding-left: 16px
      max-width: 100%
      overflow: hidden
    li
      line-height: 180%

.ticket-bg
  position: relative
  &.ticket-bg--horizon
    background:
      image: url('~assets/ticket-bg-horizon.png')
      repeat: no-repeat
      size: contain
    width: 640px
    height: 198px
    .ticket-name
      position: relative
      padding-top: 26px
      left: 220px
      font-size: 24px
      font-weight: bold
    .seat-number
      position: relative
      left: 220px
      padding-top: 8px
      font-size: 16px
      @extend %clearfix
      .section
        float: left
        margin-right: 3px
      .seat
        float: left
    .user-info
      position: relative
      left: 220px
      padding-top: 10px
      font-size: 13px
      @extend %clearfix
      .user-info-row
        margin-bottom: 4px
        font-weight: bold
        @extend %clearfix
        .info-name
          float: left
        .info-content
          float: left
    .qr-code
      position: absolute
      right: 52px
      top: 95px
      width: 80px
      height: 80px
      overflow: hidden
      img
        width: 100px
        height: 100px
        margin:
          left: -10px
          top: -10px
  &.ticket-bg--straight
    background:
      image: url('~assets/ticket-bg-straight.png')
      repeat: no-repeat
      size: contain
    width: 280px
    height: 827px
    margin: 0 auto
    padding-right: 20px
    .ticket-name
      padding-top: 350px
      font-size: 34px
      font-weight: bold
      text-align: center
    .seat-number
      font-size: 26px
      text-align: center
      @extend %clearfix
      .section
        display: inline-block
        margin-right: 8px
      .seat
        display: inline-block
    .user-info
      margin-top: 40px
      text-align: center
      @extend %clearfix
      .user-info-row
        font-size: 16px
        @extend %clearfix
        .info-name
          display: inline-block
        .info-content
          display: inline-block
    .qr-code
      position: relative
      margin-top: 50px
      left: 50%
      transform: translateX(-50%)
      width: 200px
      height: 200px
      overflow: hidden
      img
        width: 240px
        height: 240px
        margin:
          left: -20px
          top: -20px

.coupons
  .title
    color: $red
    font-size: 18px
  .coupons-wrap
  .coupon
    padding: 8px 16px 16px 16px
    border-bottom: 1px solid $grey-dark
    margin-bottom: 16px
    .source
      color: #fff
      background-color: $grey-dark
      font-size: 12px
      padding: 1px 4px
      display: inline-block
      margin-bottom: 8px
      text-decoration: none
      &:hover
        background-color: $red
    .name
      color: #fff
      font-size: 18px
    .code
      color: $grey
      font-size: 22px
      font-weight: bold
      border: 1px solid $red
      padding: 6px 8px
      margin: 8px 0
      letter-spacing: 2px
      display: inline-block
      background-color: #000
    .description
      color: $grey
      font-size: 13px
.btn-xs
  border: 1px solid $red
  margin-left: 3px
  &:hover
    color: #fff
    background-color: $red
</style>



// WEBPACK FOOTER //
// user.vue?4fe3045e